import type { ReactNode, SVGProps } from "react";

export function HelpIcon(props: SVGProps<SVGSVGElement>): ReactNode {
	return (
		<svg
			fill="none"
			height="15"
			viewBox="0 0 13 15"
			width="13"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M11.5937 3.47139C12.0487 3.73673 12.3282 4.23339 12.325 4.77006V9.62606C12.325 10.1654 12.037 10.6627 11.5723 10.9247L7.1848 13.7714C6.96728 13.8939 6.72315 13.9581 6.475 13.9581C6.22685 13.9581 5.98272 13.8939 5.7652 13.7714L1.3777 10.9247C1.15031 10.7973 0.96048 10.6095 0.828067 10.381C0.695655 10.1526 0.625521 9.89183 0.625 9.62606V4.76939C0.625 4.23006 0.91295 3.73339 1.3777 3.47139L5.7652 0.81806C5.98915 0.691417 6.24072 0.625 6.49645 0.625C6.75218 0.625 7.00375 0.691417 7.2277 0.81806L11.6152 3.47139H11.5937Z"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.25"
			/>
			<path
				d="M6.4751 9.95801V9.96467"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.25"
			/>
			<path
				d="M6.475 7.95801C6.76734 7.95891 7.05144 7.85873 7.28143 7.67363C7.51141 7.48854 7.67386 7.22934 7.74253 6.9379C7.8112 6.64645 7.78209 6.33977 7.6599 6.06739C7.53771 5.795 7.32957 5.5728 7.0691 5.43668C6.81051 5.30082 6.51472 5.2587 6.22983 5.31716C5.94493 5.37562 5.68771 5.53123 5.5 5.75868"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.25"
			/>
		</svg>
	);
}
